import React, { useEffect, useState } from "react";
import { GrFormCheckmark } from "react-icons/gr";
import PropTypes from 'prop-types';
import { getPrivileges, updatePrivileges } from "../utils/privilegeUtils";
import Error from "./Error";
import Loading from "./Loading";
import FormInput from "../components/FormInput";
import { createDeepClone } from "../utils/utils";

function UserPrivileges({ isMobile, currentProfile }) {
    const [email, setEmail] = useState('');
    const [accessControl, setAccessControl] = useState(null);
    const [originalAccessControl, setOriginalAccessControl] = useState(null);
    const [accessControlErrors, setAccessControlErrors] = useState({ "isAdminError": "" });
    const [submitted, setSubmitted] = useState(false);
    const [updateError, setUpdateError] = useState('');
    const [updateSuccess, setUpdateSuccess] = useState('');

    useEffect(() => {
        document.title = 'User Privileges';
    });

    const handleChange = async (e) => {
        if(e.hasOwnProperty("isAdmin")) {
            let accessControlClone = createDeepClone(accessControl);
            Object.assign(accessControlClone, e);
            setAccessControl(accessControlClone);
        } else {
            setAccessControlErrors({ "isAdminError": 'There was a problem.'})
        }
    };

    const handleSubmit = async (e) => {
        setSubmitted(true);
        e.preventDefault();
        let response = await updatePrivileges(accessControl.sub, accessControl.isAdmin, currentProfile.accessToken);
        // console.log(response);
        if(response) {
            let emailUpdated = email;
            setUpdateSuccess(`Successfully updated ${emailUpdated}'s privileges`);
            setOriginalAccessControl(null);
            setAccessControl(null);
            setEmail('');
            setSubmitted(false);
        } else {
            setUpdateError("Failed to update user privileges.");
        }
    };

    if(currentProfile && currentProfile.isAdmin) {
        return (
            <div style={{ "minHeight":"92vh" }} className="w3-content w3-container w3-padding-64" id="about">
                <div style={{ "display": "flex", "justifyContent": "center" }}>
                    <div style={{ "maxWidth": "650px" }}>
                        <h4><b>User Privileges</b></h4>
                        <React.Fragment>
                            <p>Please enter the email address of the user whose privileges you want to adjust.</p>
                            <div style={{ "display": "flex" }}>
                                <input
                                    className="w3-input w3-border"
                                    style={{ "width":"100%", "marginRight": "16px" }}
                                    placeholder="Email"
                                    name="email"
                                    value={email}
                                    type="text"
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setUpdateSuccess('');
                                        setUpdateError('');
                                        setSubmitted(false);
                                        setEmail(e.target.value);
                                    }}
                                    id="email"
                                />
                                <button 
                                    className="sage-green hidden-btn" 
                                    onClick={async () => { 
                                        let accessControl = await getPrivileges(email, currentProfile.accessToken);
                                        setOriginalAccessControl(accessControl);
                                        setAccessControl(accessControl);
                                    }} 
                                    disabled={!email} 
                                    style={{ "width": "48px" }}
                                >
                                    <GrFormCheckmark style={{ "transform": "scale(2)" }}/>
                                </button>
                            </div>
                        </React.Fragment>
                        {accessControl ? (
                            <div style={{ "padding": "16px", "borderRadius": "8px", "marginTop": "32px" }} className="w3-card">
                                <div style={{ "display": "flex", "marginBottom": "16px" }}>
                                    <p style={{ "margin": "0px" }}><b>Email</b></p>
                                    <div style={{ "width": "100%", "display": "flex", "justifyContent": "right" }}>
                                        <p style={{ "margin": "0px" }}><b>Admin Privileges</b></p>
                                    </div>
                                </div>
                                <div style={{ "display": "flex" }}>
                                    <p style={{ "margin": "0px" }}>{email}</p>
                                    <div style={{ "width": "100%" }}>
                                    <FormInput style={{ "justifyContent": "right", "width": "100%" }} errorStyle={{ "textAlign": "right", "marginBottom": "0px" }} isMobile={isMobile} updateParent={handleChange} name="isAdmin" type="switch" object={accessControl} errors={accessControlErrors} />
                                    </div>
                                </div>
                                <div style={{ "width": "100%", "display": "flex", "justifyContent": "right", "marginTop": "16px" }}>
                                    <button 
                                        className="main-button" 
                                        onClick={(e) => handleSubmit(e)} 
                                        disabled={(submitted || (accessControl.isAdmin === originalAccessControl.isAdmin))}
                                    >
                                        Update Privileges
                                    </button>
                                </div>
                            </div>
                        ) : null}
                        <div className="form-error" style={{ "marginTop": "32px", "textAlign": "right" }}>{updateError}</div>
                        <div className="form-error" style={{ "marginTop": "32px", "textAlign": "right", "color":"green" }}>{updateSuccess}</div>
                    </div>
                </div>
            </div>
        );
    } else if((!currentProfile && typeof currentProfile === "boolean") || (currentProfile && !currentProfile.isAdmin)) {
        return(
            <Error isMobile={isMobile} type={"login"} />
        );
    } else {
        return(
            <Loading isMobile={isMobile} text={`User Privileges`} />
        );
    }
}

UserPrivileges.propTypes = {
    isMobile: PropTypes.bool,
    currentProfile: PropTypes.object
};

export default UserPrivileges;